import "./corporate-search.scss"

const hiddenClass = "d-none"

const container = {
  corporateNumber: { element: null, input: "", search: "" },
  name: { element: null, input: "", search: "" },
  nameKana: { element: null, input: "", search: "" },
  postCode: { element: null, input: "", search: "" },
  prefecture: { element: null, input: "", search: "" },
  city: { element: null, input: "", search: "" },
  street: { element: null, input: "", search: "" },
}

const fetchCorporateData = async (corporateNumber) => {
  const response = await fetch(`/api/v1/corporates/${corporateNumber}`).catch(e => { throw e })
  if (! response.ok) throw new Error("API request failed.")
  const data = await response.json()
  return data
}

const resetSearchResults = () => {
  Object.keys(container).forEach(key => { container[key].search = "" })
}

const getDifferences = () => {
  const differences = []
  Object.keys(container).forEach(key => {
    if (container[key].input !== container[key].search) {
      differences.push(key)
    }
  })
  return differences
}

const activate = (elements) => {
  setInputElements(elements)
  setSearchHandler()

  container.corporateNumber.element.dispatchEvent(new Event("input"))
}

const setInputElements = (elements) => {
  Object.keys(elements).forEach(key => {
    container[key].input = elements[key].value
    container[key].element = elements[key]
    container[key].element.addEventListener("input", (event) => {
      container[key].input = event.target.value
      updateView()
    })
  })
}

const setSearchHandler = async () => {
  container.corporateNumber.element.addEventListener("input", async (event) => {
    if (! container.corporateNumber.input.match(/^\d{13}$/)) {
      resetSearchResults()
      updateView()
      return
    }

    try {
      const data = await fetchCorporateData(container.corporateNumber.input)
      container.corporateNumber.search = data.corporate_number
      container.name.search = data.name
      container.nameKana.search = data.furigana
      container.postCode.search = data.post_code
      container.prefecture.search = data.prefecture_name
      container.city.search = data.city_name
      container.street.search = data.street_number
    } catch (_) {
      resetSearchResults()
    }

    updateView()
  })
}

const copyResultValuesToInput = () => {
  if (! container.corporateNumber.search) return

  Object.keys(container).forEach(key => {
    container[key].input = container[key].search
    container[key].element.value = container[key].search
  })
  updateView()
}

const updateView = () => {
  const differences = getDifferences()
  document.querySelectorAll(".result-container").forEach(element => {
    element.querySelectorAll(".material-icons").forEach(icon => { icon.classList.remove(hiddenClass) })
    const dataKey = element.dataset.key
    element.querySelector(differences.includes(dataKey) ? ".icon-ok" : ".icon-ng").classList.add(hiddenClass)

    element.querySelector(".result-content").innerHTML = container[dataKey].search
  })
}

export default {
  activate,
  copyResultValuesToInput,
}
